// = Libs =
import { FC } from 'react';

// = Containers & Components =
import Container from '@/common/containers/container/container';
import MonitoringSettingsButtons from './monitoring-settings-buttons/monitoring-settings-buttons';
import { SplitContent } from '@/common/containers/split-content/split-content';
import PollSettings from '@/pages/poll/componens/poll-settings/poll-settings';
import { BEFullPollModel, updatePoll } from '@/services/poll.service';
import { withAlert } from '@/helpers/notificationHelper';

const PollSettingsTab: FC<{
  canPublish: boolean;
  pollData: BEFullPollModel;
}> = (props) => {
  const { canPublish, pollData } = props;

  return (
    <Container>
      <SplitContent
        Content={
          <PollSettings
            initialValues={pollData}
            orgId={pollData?.author}
            handleSubmit={(values) =>
              withAlert(
                () => updatePoll(values, pollData.pollId),
                'Данные обновлены',
                'Не удалось обновить данные'
              )
            }
            disableFields={['author', 'periodicType']}
          />
        }
        SideBar={<MonitoringSettingsButtons canPublish={canPublish} />}
        Position={true}
      />
    </Container>
  );
};

export default PollSettingsTab;
